$(document).ready(function () {
  if (counter == 1) {
    $('input[type=radio]').prop('checked', true);
  }
});
